import { RegularModal } from '@/components_deprecated'
import { Modal } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import React from 'react'
import { isMobileOnly } from 'react-device-detect'

interface InfoContentData {
  text: string
  videoUrl: string
}

interface InfoModalProps {
  open: boolean
  onClose: () => void
  content: InfoContentData | null | undefined
}

export const InfoModal: React.FC<InfoModalProps> = ({
  open,
  onClose,
  content,
}) => {
  const translations = useTranslate({
    close: 'common.close',
  })

  return (
    <Modal
      open={open}
      offset={isMobileOnly ? 8 : 36}
      placement="top-center"
      direction="from-top"
      onClose={onClose}
    >
      <RegularModal
        width="600px"
        submitText={translations.close}
        onSubmit={onClose}
      >
        <div>
          {content && content.videoUrl && (
            <iframe
              width="100%"
              height="315"
              src={content.videoUrl}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{ marginBottom: '1rem' }}
            />
          )}
          <p>{content ? content.text : ''}</p>
        </div>
      </RegularModal>
    </Modal>
  )
}
